import { render, staticRenderFns } from "./NoUserIcon.vue?vue&type=template&id=7b64927c&"
import script from "./NoUserIcon.vue?vue&type=script&lang=js&"
export * from "./NoUserIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports